import { useState } from 'react';
import { Text, Icon, IconButton, Spinner, SpinnerSize } from '@fluentui/react';
import { useFileBrowserStore } from '@/hooks';

// Home / site-picker shown when no site is selected. Lists the CRG sites the
// signed-in user can access; picking one opens that site's file browser.
export function SiteHomeView() {
  const { sites, sitesLoaded, authStale, selectSite, loadSites } = useFileBrowserStore();
  const [refreshing, setRefreshing] = useState(false);
  const accessible = sites.filter((s) => s.accessible).sort((a, b) => a.name.localeCompare(b.name));

  const handleRefresh = async () => {
    setRefreshing(true);
    try {
      // Force a fresh token so a manual refresh reflects current site access.
      await loadSites(true);
    } finally {
      setRefreshing(false);
    }
  };

  return (
    <div className="site-home">
      <div className="site-home-header">
        <Text variant="large" className="site-home-title">
          SharePoint Sites
        </Text>
        <IconButton
          iconProps={{ iconName: 'Refresh' }}
          title="Refresh site list"
          ariaLabel="Refresh site list"
          disabled={refreshing}
          onClick={handleRefresh}
        />
      </div>

      {!sitesLoaded ? (
        <div className="site-home-loading">
          <Spinner size={SpinnerSize.large} label="Loading sites" />
        </div>
      ) : accessible.length === 0 ? (
        <Text className="site-home-empty">
          {authStale
            ? 'Your sites could not be loaded because the connection was lost. Use Reconnect above.'
            : 'You do not have access to any configured SharePoint site. Ask an owner to add you, then refresh.'}
        </Text>
      ) : (
        <div className="site-home-grid">
          {accessible.map((s) => (
            <button
              key={s.id}
              type="button"
              className="site-card"
              onClick={() => selectSite(s.id)}
              title={`Open ${s.name}`}
            >
              <Icon iconName="SharepointLogo" className="site-card-icon" />
              <span className="site-card-name">{s.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
